import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { OrderDrawer } from "@/components/OrderDrawer";
import { OrderProvider } from "@/context/OrderContext";
import { LangProvider } from "@/context/LangContext";
import Admin from "@/pages/Admin";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Plants from "@/pages/Plants";
import Tissue from "@/pages/Tissue";
import Souvenir from "@/pages/Souvenir";
import Contact from "@/pages/Contact";

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id = requestAnimationFrame(function raf(t) { lenis.raf(t); id = requestAnimationFrame(raf); });
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
};

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
        <OrderProvider>
          <ScrollTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tentang-kami" element={<About />} />
              <Route path="/katalog-tanaman" element={<Plants />} />
              <Route path="/kultur-jaringan" element={<Tissue />} />
              <Route path="/souvenir-hampers" element={<Souvenir />} />
              <Route path="/kontak" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <OrderDrawer />
          <Toaster position="bottom-center" richColors />
        </OrderProvider>
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
